import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Scroll-triggered fade + rise
export function Reveal({ children, delay = 0, y = 40, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 1, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal (hero signature moment)
export function MaskedLines({ lines, className = "", lineClassName = "", stagger = 0.12, delay = 0.2 }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </div>
  );
}

export const EASE_LUXE = EASE;
